var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.463,
    height: 17.693,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffdb4d",
    d: "M19.345 16.364 10.529.416a.93.93 0 0 0-1.55 0L.119 16.364a.886.886 0 0 0 .749 1.329h17.72a.886.886 0 0 0 .753-1.329zm-9.613-1.772a.886.886 0 1 1 .886-.886.886.886 0 0 1-.886.886zm.886-3.544a.886.886 0 0 1-1.772 0V7.061a.886.886 0 0 1 1.772 0z",
    "data-name": "Path 16677"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3f59ea9c37e699c9f800e3bdd7ea45ca.svg";
export { ForwardRef as ReactComponent };